const BullerLoadingOverlay = {
  show: (parent = document.body, position = "fixed", count = 5) => {
    let loadingOverlay = document.createElement("div");
    loadingOverlay.id = "buller-loading-overlay";
    loadingOverlay.className = "buller-loading-overlay";
    loadingOverlay.style.opacity = 0;
    loadingOverlay.style.transition = "opacity 0.5s ease-in-out";
    loadingOverlay.style.position = position;
    loadingOverlay.style.zIndex = Number.MAX_SAFE_INTEGER;
    for (let i = 0; i < count; i++) {
      let dot = document.createElement("div");
      dot.className = "dot";
      loadingOverlay.appendChild(dot);
    }

    parent.appendChild(loadingOverlay);
    setTimeout(() => {
      loadingOverlay.style.opacity = 1;
    }, 100);
  },

  hide: async (element = "#buller-loading-overlay") => {
    await new Promise((resolve) => setTimeout(resolve, 500));
    let loading = document.querySelector(element);
    if (loading) {
      loading.style.opacity = 0;
      loading.addEventListener("transitionend", () => {
        loading.remove();
      });
    }
  },
};

const ShowContentLoading = {
  show: ({ parent = document.body, id = "content-loading-overlay" }) => {
    if (document.getElementById(id)) return;

    const currentPosition = getComputedStyle(parent).position;
    if (currentPosition === "static") {
      parent.style.position = "relative";
    }

    parent.classList.add("pe-none");
    const overlay = document.createElement("div");
    overlay.id = id;
    overlay.className = "content-loading-overlay d-flex flex-column justify-content-center align-items-center";

    overlay.style.position = "absolute";
    overlay.style.top = "0";
    overlay.style.left = "0";
    overlay.style.width = parent.getBoundingClientRect().width  + "px";
    overlay.style.height = parent.scrollHeight + "px";  
    overlay.style.backgroundColor = "rgba(255, 255, 255, 0.8)";
    overlay.style.zIndex = "9999";
    overlay.style.transition = "opacity 0.3s ease-in-out";
    overlay.style.opacity = "0";

    const spinner = document.createElement("div");
    spinner.className = "spinner-border text-primary";
    spinner.role = "status";

    const hiddenSpan = document.createElement("span");
    hiddenSpan.className = "visually-hidden";
    hiddenSpan.textContent = "Loading...";
    spinner.appendChild(hiddenSpan);

    const text = document.createElement("p");
    text.className = "text-primary mt-2 mb-0";
    text.textContent = "נא המתן";

    overlay.appendChild(spinner);
    overlay.appendChild(text);
    parent.appendChild(overlay);

    // הפעל מעבר
    requestAnimationFrame(() => {
      overlay.style.opacity = "1";
    });
  },

  hide: ({ parent = document.body, id = "content-loading-overlay" }) => {
    const overlay = document.getElementById(id);
    if (!overlay) return;

    overlay.style.opacity = "0";
    overlay.addEventListener("transitionend", () => {
      overlay.remove();
      parent.classList.remove("pe-none");
    }, { once: true });
  }
};







const ShowOverlayLoading = () => {
  let loading = document.getElementById(`loading-overlay`);
  if (loading) {
    loading.style.display = "flex";
    loading.style.position = "fixed";
  } else {
    let loadingOverlay = document.createElement("div");
    loadingOverlay.id = "loading-overlay";
    loadingOverlay.style.display = "flex";
    loadingOverlay.style.position = "fixed";

    let spinner = document.createElement("div");
    spinner.className = "spinner-border text-light";
    spinner.role = "status";

    let visuallyHiddenSpan = document.createElement("span");
    visuallyHiddenSpan.className = "visually-hidden";
    visuallyHiddenSpan.textContent = "Loading...";

    let textElement = document.createElement("p");
    textElement.className = "text-light";
    textElement.textContent = "נא המתן";

    spinner.appendChild(visuallyHiddenSpan);
    loadingOverlay.appendChild(spinner);
    loadingOverlay.appendChild(textElement);
    document.body.appendChild(loadingOverlay);
  }
};

const HideOverlayLoading = (element = "#loading-overlay") => {
  let loading = document.querySelector(element);
  if (loading) {
    loading.classList.add("hide-loading-overlay");
    loading.addEventListener("transitionend", () => {
      loading.remove();
    });
  }
};

/* button loading */
const ShowLoading = (buttonElement) => {
  if (!buttonElement) return;
  let existSpinner = buttonElement.querySelector("#spinner-box");
  if (existSpinner) {
    existSpinner.remove();
  }
  buttonElement.classList.add("position-relative");
  // Disable the button and add a spinner
  buttonElement.disabled = true;
  // buttonElement.classList.add('position-relative');
  let spinner = document.createElement("span");
  spinner.id = "spinner-box";
  // spinner.style.marginRight = "5px";
  spinner.style.position = "absolute";
  spinner.style.left = "50%";
  spinner.style.transform = "translateX(-50%)";
  spinner.style.position = "absolute";

  spinner.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>`;
  buttonElement.appendChild(spinner);

  // Add an overlay to block the page
  let overlay = document.createElement("div");
  overlay.id = "loading-overlay-wrapper";
  overlay.style.position = "fixed";
  overlay.style.top = 0;
  overlay.style.left = 0;
  overlay.style.width = "100%";
  overlay.style.height = "100%";
  overlay.style.zIndex = Number.MAX_SAFE_INTEGER; // High z-index to cover the page
  overlay.style.pointerEvents = "all"; // Block interactions
  overlay.style.cursor = "wait";
  document.body.appendChild(overlay);
};

const HideLoading = async (buttonElement) => {
  if (!buttonElement) return;
  buttonElement.disabled = false;
  let spinner = buttonElement.querySelector("#spinner-box");
  if (spinner) {
    spinner.classList.add("fade-out");
    setTimeout(() => {
      spinner.remove();
    }, 310);
  }

  let overlay = document.getElementById("loading-overlay-wrapper");
  if (overlay) {
    overlay.remove();
  }
};
const HideBullerLoading = () => {
  const content = document.querySelector(".buller-loading-active");
  const overlay = document.querySelector(".buller-loading-overlay");

  setTimeout(() => {
    if (content) content.classList.add("hide-buller");
    if (overlay) {
      overlay.classList.add("buller-loading-hidden");
      overlay.addEventListener("animationend", (e) => {
        overlay.remove();
      });
    }
  }, 100);
};

const RemoveSkeletonLoaders = (container = '') => {
  const containerElm = document.querySelector(container)
  if(!containerElm) return;
  const skeletons = containerElm.querySelectorAll(".skeleton-loader-row");
  skeletons.forEach((skeleton) => {
    skeleton.classList.add("fade-out");
    setTimeout(() => {
      skeleton.classList.add("d-none");
    }, 100);
    setTimeout(() => {
      skeleton.remove();
    }, 300);
  });
};


const CreateLoadingSpinner = ({parent,id}) => {
  // Check if already exists
  const existing = parent.querySelector(`#${id}`);
  if (existing) return existing;

  // Create wrapper
  const wrapper = document.createElement("div");
  wrapper.className = "text-center d-flex flex-column align-items-center justify-content-center";
  wrapper.id = id;
  wrapper.style.position = "absolute";
  wrapper.style.top = "50%";
  wrapper.style.left = "50%";
  wrapper.style.transform = "translate(-50%, -50%)";
  wrapper.style.zIndex = "1000";

  // Create spinner
  const spinner = document.createElement("div");
  spinner.className = "spinner-border text-danger";
  spinner.style.width = "4rem";
  spinner.style.height = "4rem";
  spinner.setAttribute("role", "status");

  const spinnerText = document.createElement("span");
  spinnerText.className = "visually-hidden";
  spinnerText.textContent = "Loading...";
  spinner.appendChild(spinnerText);

  // Visible Hebrew message
  const message = document.createElement("div");
  message.textContent = "נא המתן";
  message.className = "mt-3 text-danger fw-bold";

  // Append children
  wrapper.appendChild(spinner);
  wrapper.appendChild(message);
  parent.style.position = "relative";
  parent.appendChild(wrapper);

  return wrapper;
};

const RemoveLoadingSpinner = ({parent,id}) => {
  const spinner = parent.querySelector(`#${id}`);
  if (spinner) spinner.remove();
};